import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const ProfileSecondaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] sm:w-auto",
})``;

export const ProfilePrimaryButton = styled.button.attrs({
  className: "brand-button inline-flex w-full items-center justify-center gap-2 px-4 py-3 text-sm sm:w-auto",
})``;

export const ProfileSection = styled.div.attrs({ className: "mt-6" })``;

export const ProfileStatsGrid = styled.div.attrs({
  className: "mt-6 grid gap-5 md:grid-cols-2",
})``;

export const ProfileHeroLayout = styled.div.attrs({
  className: "flex flex-col gap-5 sm:flex-row sm:items-center",
})``;

export const ProfilePreviewImage = styled(FallbackImage).attrs({
  className: "h-24 w-24 shrink-0 rounded-[22px] sm:h-28 sm:w-28",
})``;

export const ProfileHeroContent = styled.div.attrs({ className: "min-w-0 space-y-2" })``;

export const ProfileHeroNameRow = styled.div.attrs({
  className: "flex flex-wrap items-center gap-3",
})``;

export const ProfileHeroName = styled.p.attrs({
  className: "text-xl font-semibold text-[var(--brand-ink)] sm:text-2xl",
})``;

export const ProfileHeroMeta = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const ProfileContactRow = styled.div.attrs({
  className:
    "flex gap-4 flex-wrap items-center",
})``;

export const ProfileContactItem = styled.div.attrs({
  className: "flex min-w-0 items-center gap-2 text-sm leading-6 text-[var(--brand-ink)]",
})``;

export const ProfileContactIcon = styled.span.attrs({
  className: "mt-0.5 shrink-0 text-[var(--brand-cool)]",
})``;

export const ProfileWalletRow = styled.div.attrs({
  className: "flex flex-wrap items-center justify-between gap-4",
})``;

export const ProfileWalletLabel = styled.div.attrs({
  className: "flex items-center gap-3 text-base font-semibold text-[var(--brand-ink)]",
})``;

export const ProfileWalletMeta = styled.div.attrs({
  className: "flex flex-wrap items-center gap-3 sm:justify-end",
})``;

export const ProfileWalletStatus = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const ProfileOptionRow = styled.div.attrs({
  className: "flex w-full flex-wrap gap-2 sm:w-auto",
})``;

export const ProfileOptionButton = styled.button.attrs<{ $isActive?: boolean }>(({ $isActive }) => ({
  className: `inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm sm:w-auto ${
    $isActive ? "brand-button" : "brand-button-secondary"
  }`,
  type: "button",
}))`` as any;

export const ProfileWorkspaceCard = styled.section.attrs({
  className: "brand-panel",
})``;

export const ProfileWorkspaceHeader = styled.div.attrs({
  className:
    "flex min-w-0 flex-col gap-3 lg:flex-row lg:items-center lg:justify-between [&>*:last-child]:w-full sm:[&>*:last-child]:w-auto",
})``;

export const ProfileWorkspaceTitle = styled.h2.attrs({
  className: "break-words text-lg font-semibold text-[var(--brand-ink)]",
})``;

export const ProfileWorkspaceSubtitle = styled.p.attrs({
  className: "mt-1 text-[13px] text-[var(--brand-muted)]",
})``;
